import AnimateHeight from 'react-animate-height';
import { FlowMode } from '~/models/FlowMode';
import { ProductType } from '~/models/product/ProductType';
import { ProductTypeConfig } from '~/models/product/ProductTypeConfig';
import { SelectionMode } from '~/models/SelectionModel';
import { AdditionalComponents } from '../../campaign/components/product-group/components/bundle-additional-components/AdditionalComponents';
import { ProductBundleHeader } from '../../campaign/components/product-group/product-bundle/ProductBundleHeader';
import { ProductCard } from '../../campaign/components/product-group/product-cards/ProductCard';
import { useBasket } from '../useBasket';
import { MappedGroup } from '../useMappedBundles';
import { getFlowMode } from '../v2.utils';

export const ProductBundleV2: React.FC<{
  mappedGroup: MappedGroup;
  config: ProductTypeConfig;
  type: ProductType;
  index: number;
  previousBundleId: string | undefined;
}> = ({ mappedGroup: { bundle, selectedInBundle, visibleItems }, config, type, index, previousBundleId }) => {
  const selectProduct = useBasket((s) => s.selectProduct);
  const openBundle = useBasket((s) => s.openBundle);
  const showBundle = useBasket((s) => s.showBundle);
  const setActiveBundle = useBasket((s) => s.setActiveBundle);
  const activeBundleId = useBasket((s) => s.activeBundleId);
  const bundleVisibility = useBasket((s) => s.bundleVisibility)[bundle.id] ?? {};

  const components = selectedInBundle.map((p) => p.displayData.additionalComponent).filter((a) => a != null);

  return (
    <div key={bundle.id} className="product-bundle">
      <ProductBundleHeader
        isOpen={bundleVisibility.isOpen}
        isVisible={bundleVisibility.isVisible}
        config={config}
        index={index}
        selectedInBundle={selectedInBundle}
        bundleId={bundle.id}
        activeBundleId={activeBundleId[type] ?? ''}
        deselectProduct={() => {
          selectedInBundle.forEach((p) => selectProduct(p, bundle));
          openBundle(bundle.id, true);
        }}
        removeBundle={() => {
          selectedInBundle.forEach((p) => selectProduct(p, bundle));
          if (previousBundleId) {
            setActiveBundle(type, previousBundleId);
          }
          openBundle(bundle.id, false);
          showBundle(bundle.id, false);
        }}
        flowMode={getFlowMode(type)}
      />

      {/* BUNDLE ITEMS */}
      <AnimateHeight duration={300} animateOpacity height={bundleVisibility.isOpen ? 'auto' : 0}>
        <ul style={{ display: 'flex', flexWrap: 'wrap', listStyleType: 'none', padding: 0 }}>
          {visibleItems.map((p) => (
            <ProductCard
              key={p.id}
              isOpen={true}
              isSelected={selectedInBundle.some((sp) => sp.id === p.id)}
              product={p}
              shouldFocus={false}
              toggleProductSelection={() => {
                const willAddToBundle = selectedInBundle.length === 0;
                selectProduct(p, bundle);
                // close single selection bundle if in progressive mode
                if (
                  willAddToBundle &&
                  bundle.selectionConfig.selectionMode === SelectionMode.Single &&
                  getFlowMode(p.productType) === FlowMode.Progressive
                ) {
                  openBundle(bundle.id, false);
                }
              }}
            />
          ))}
        </ul>
      </AnimateHeight>
      {bundleVisibility.isOpen && <AdditionalComponents components={components} />}
    </div>
  );
};
